import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Pdfgenerator"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { gr.tech.pdfgenerator.pages.IndexPage() }
        ctx.router.register("/inputs") { gr.tech.pdfgenerator.pages.InputPage() }
        ctx.router.register("/lightingproposal") { gr.tech.pdfgenerator.pages.proposalGeneratePage()
                }
        ctx.router.register("/login") { gr.tech.pdfgenerator.pages.UserLoginPage() }
        ctx.router.register("/msa") { gr.tech.pdfgenerator.pages.msaGeneratePage() }
        ctx.router.register("/projects") { gr.tech.pdfgenerator.pages.ProjectsPage() }
        ctx.router.register("/tierthree") { gr.tech.pdfgenerator.pages.tierThreeGeneratePage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("tab-box", gr.tech.pdfgenerator.components.tabBoxStyle)
        ctx.theme.registerStyle("tab-selected-name",
                gr.tech.pdfgenerator.components.tabSelectedNameStyle)
        ctx.theme.registerStyle("pdf-content",
                gr.tech.pdfgenerator.components.layouts.PDFContentStyle)
        ctx.theme.registerStyle("page-content", gr.web.icyleds.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("copy-string-box",
                gr.tech.pdfgenerator.components.widgets.CopyStringBoxStyle)
        ctx.theme.registerStyle("copy-container",
                gr.tech.pdfgenerator.components.widgets.CopyContainerStyle)
        ctx.theme.registerStyle("copied-overlay-base",
                gr.tech.pdfgenerator.components.widgets.CopiedOverlayBase)
        ctx.theme.registerStyle("copied-overlay-hidden",
                gr.tech.pdfgenerator.components.widgets.CopiedOverlayHidden)
        ctx.theme.registerStyle("copied-overlay-visible",
                gr.tech.pdfgenerator.components.widgets.CopiedOverlayVisible)
        ctx.theme.registerStyle("hover-link", gr.web.icyleds.components.sections.HoverLinkStyle)
        ctx.theme.registerStyle("nav-header", gr.web.icyleds.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("simple-span", gr.tech.pdfgenerator.styles.SimpleSpanStyle)
        ctx.theme.registerStyle("button", gr.tech.pdfgenerator.styles.ButtonStyle)
        ctx.theme.registerStyle("table-header", gr.tech.pdfgenerator.styles.TableHeaderStyle)
        ctx.theme.registerStyle("table-row-hover", gr.tech.pdfgenerator.styles.TableRowHoverStyle)
        ctx.theme.registerStyle("table-row-button", gr.tech.pdfgenerator.styles.TableRowButtonStyle)
        ctx.theme.registerStyle("show-more-button", gr.tech.pdfgenerator.styles.ShowMoreButtonStyle)
        ctx.theme.registerStyle("general-button", gr.tech.pdfgenerator.styles.GeneralButtonStyle)
        ctx.theme.registerStyle("medium-green-hover-link",
                gr.tech.pdfgenerator.styles.MediumGreenHoverLink)
        ctx.theme.registerStyle("home-page", gr.tech.pdfgenerator.styles.HomePageStyle)
        ctx.theme.registerStyle("home-header", gr.tech.pdfgenerator.styles.HomeHeaderStyle)
        ctx.theme.registerStyle("input-label", gr.tech.pdfgenerator.styles.InputLabelStyle)
        ctx.theme.registerStyle("string-input", gr.tech.pdfgenerator.styles.stringInputStyle)
        ctx.theme.registerStyle("prop-derivative-label",
                gr.tech.pdfgenerator.styles.PropDerivativeLabelStyle)
        ctx.theme.registerStyle("prop-derivative-span",
                gr.tech.pdfgenerator.styles.PropDerivativeSpanStyle)
        ctx.theme.registerStyle("msa-input-title", gr.tech.pdfgenerator.styles.MSAInputTitleStyle)
        ctx.theme.registerStyle("msa-deliverable-table",
                gr.tech.pdfgenerator.styles.MSADeliverableTableStyle)
        ctx.theme.registerStyle("msa-deliverable-column-preview",
                gr.tech.pdfgenerator.styles.MSADeliverableColumnPreview)
        ctx.theme.registerStyle("msa-deliverable-row-preview",
                gr.tech.pdfgenerator.styles.MSADeliverableRowPreview)
        ctx.theme.registerStyle("msa-deliverable-text-preview",
                gr.tech.pdfgenerator.styles.MSADeliverableTextPreview)
        ctx.theme.registerStyle("msa-sample-deliverable-column-preview",
                gr.tech.pdfgenerator.styles.MSASampleDeliverableColumnPreview)
        ctx.theme.registerStyle("msa-sample-deliverable-row-preview",
                gr.tech.pdfgenerator.styles.MSASampleDeliverableRowPreview)
        ctx.theme.registerStyle("msa-sample-deliverable-text-preview",
                gr.tech.pdfgenerator.styles.MSASampleDeliverableTextPreview)
        ctx.theme.registerStyle("msa-table-control-cell",
                gr.tech.pdfgenerator.styles.MSATableControlCellStyle)
        ctx.theme.registerStyle("msa-table-grip", gr.tech.pdfgenerator.styles.MSATableGripStyle)
        ctx.theme.registerStyle("msa-table-delete-button",
                gr.tech.pdfgenerator.styles.MSATableDeleteButtonStyle)
        ctx.theme.registerStyle("msa-add-row-button",
                gr.tech.pdfgenerator.styles.MSAAddRowButtonStyle)
        ctx.theme.registerStyle("grgreen", gr.tech.pdfgenerator.styles.grgreen)
        ctx.theme.registerStyle("inserted-field-text",
                gr.tech.pdfgenerator.styles.insertedFieldTextStyle)
        ctx.theme.registerStyle("pdf-table-column", gr.tech.pdfgenerator.styles.pdfTableColumnStyle)
        ctx.theme.registerStyle("pdf-header-background",
                gr.tech.pdfgenerator.styles.pdfHeaderBackground)
        ctx.theme.registerStyle("pdf-table-header", gr.tech.pdfgenerator.styles.pdfTableHeaderStyle)
        ctx.theme.registerStyle("pdf-table-text", gr.tech.pdfgenerator.styles.pdfTableTextStyle)
        ctx.theme.registerStyle("overlay-text", gr.tech.pdfgenerator.styles.overlayTextStyle)
        ctx.theme.registerStyle("logo", gr.tech.pdfgenerator.styles.LogoStyle)
        ctx.theme.registerStyle("page-title", gr.tech.pdfgenerator.styles.pageTitleStyle)
        ctx.theme.registerStyle("page-footer", gr.tech.pdfgenerator.styles.pageFooterStyle)
        ctx.theme.registerStyle("section-title-gradiant",
                gr.tech.pdfgenerator.styles.sectionTitleGradiantStyle)
        ctx.theme.registerStyle("small-section-title-gradiant",
                gr.tech.pdfgenerator.styles.smallSectionTitleGradiantStyle)
        ctx.theme.registerStyle("summary-column", gr.tech.pdfgenerator.styles.summaryColumnStyle)
        ctx.theme.registerStyle("grey-back", gr.tech.pdfgenerator.styles.greyBackStyle)
        ctx.theme.registerStyle("pdf-label-cell", gr.tech.pdfgenerator.styles.pdfLabelCellStyle)
        ctx.theme.registerStyle("pdf-cell", gr.tech.pdfgenerator.styles.pdfCellStyle)
        ctx.theme.registerStyle("table-box-padding",
                gr.tech.pdfgenerator.styles.tableBoxPaddingStyle)
        ctx.theme.registerStyle("savings-bubble", gr.tech.pdfgenerator.styles.savingsBubbleStyle)
        ctx.theme.registerStyle("savings-bubble-text",
                gr.tech.pdfgenerator.styles.savingsBubbleTextStyle)
        ctx.theme.registerStyle("env-impact-bubble",
                gr.tech.pdfgenerator.styles.envImpactBubbleStyle)
        ctx.theme.registerStyle("env-impact-text", gr.tech.pdfgenerator.styles.envImpactTextStyle)
        ctx.theme.registerStyle("delivery-input", gr.tech.pdfgenerator.styles.deliveryInputStyle)
        ctx.theme.registerStyle("row", gr.tech.pdfgenerator.styles.rowStyle)
        ctx.theme.registerStyle("column", gr.tech.pdfgenerator.styles.columnStyle)
        ctx.theme.registerStyle("column-paragraph",
                gr.tech.pdfgenerator.styles.columnParagraphStyle)
        ctx.theme.registerStyle("element-to-print", gr.tech.pdfgenerator.styles.ElementToPrintStyle)
        ctx.theme.registerStyle("general-paragraph",
                gr.tech.pdfgenerator.styles.GeneralParagraphStyle)
        ctx.theme.registerStyle("general-document-divider",
                gr.tech.pdfgenerator.styles.GeneralDocumentDividerStyle)
        ctx.theme.registerStyle("general-logo-small",
                gr.tech.pdfgenerator.styles.GeneralLogoSmallStyle)
        ctx.theme.registerStyle("pdf-status-text", gr.tech.pdfgenerator.styles.PDFStatusTextStyle)
        ctx.theme.registerStyle("pdf-column-overlay", gr.tech.pdfgenerator.styles.PDFColumnOverlay)
        ctx.theme.registerStyle("pdf-back-button", gr.tech.pdfgenerator.styles.PDFBackButtonStyle)
        ctx.theme.registerStyle("smaller-item-paragraph",
                gr.tech.pdfgenerator.styles.SmallerItemParagraphStyle)
        ctx.theme.registerStyle("bold-underline", gr.tech.pdfgenerator.styles.BoldUnderline)
        ctx.theme.registerStyle("bold-italic", gr.tech.pdfgenerator.styles.BoldItalic)
        ctx.theme.registerStyle("inserted-field", gr.tech.pdfgenerator.styles.insertedFieldStyle)
        ctx.theme.registerStyle("background", gr.tech.pdfgenerator.styles.backgroundStyle)
        ctx.theme.registerStyle("page", gr.tech.pdfgenerator.styles.pageStyle)
        ctx.theme.registerStyle("top-divider", gr.tech.pdfgenerator.styles.topDivider)
        ctx.theme.registerStyle("bottom-divider", gr.tech.pdfgenerator.styles.bottomDivider)
        ctx.theme.registerStyle("header-title", gr.tech.pdfgenerator.styles.headerTitleStyle)
        ctx.theme.registerStyle("linked-values-half",
                gr.tech.pdfgenerator.styles.linkedValuesHalfStyle)
        ctx.theme.registerStyle("headline-text", gr.tech.pdfgenerator.styles.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text",
                gr.tech.pdfgenerator.styles.SubheadlineTextStyle)
        ctx.theme.registerStyle("blue-back", gr.tech.pdfgenerator.styles.blueBackStyle)
        ctx.theme.registerStyle("light-blue-back", gr.tech.pdfgenerator.styles.lightBlueBackStyle)
        ctx.theme.registerStyle("dark-green-back", gr.tech.pdfgenerator.styles.DarkGreenBackStyle)
        ctx.theme.registerStyle("label-cell", gr.tech.pdfgenerator.styles.labelCellStyle)
        ctx.theme.registerStyle("cell", gr.tech.pdfgenerator.styles.cellStyle)
        ctx.theme.registerStyle("project-proposal-grey-back",
                gr.tech.pdfgenerator.styles.ProjectProposalGreyBackStyle)
        ctx.theme.registerStyle("t3-input-title", gr.tech.pdfgenerator.styles.T3InputTitleStyle)
        ctx.theme.registerStyle("t3-deliverable-table",
                gr.tech.pdfgenerator.styles.T3DeliverableTableStyle)
        ctx.theme.registerStyle("t3-deliverable-column-preview",
                gr.tech.pdfgenerator.styles.T3DeliverableColumnPreview)
        ctx.theme.registerStyle("t3-deliverable-row-preview",
                gr.tech.pdfgenerator.styles.T3DeliverableRowPreview)
        ctx.theme.registerStyle("t3-deliverable-text-preview",
                gr.tech.pdfgenerator.styles.T3DeliverableTextPreview)
        ctx.theme.registerStyle("t3-table-control-cell",
                gr.tech.pdfgenerator.styles.T3TableControlCellStyle)
        ctx.theme.registerStyle("t3-table-grip", gr.tech.pdfgenerator.styles.T3TableGripStyle)
        ctx.theme.registerStyle("t3-table-delete-button",
                gr.tech.pdfgenerator.styles.T3TableDeleteButtonStyle)
        ctx.theme.registerStyle("t3-add-row-button",
                gr.tech.pdfgenerator.styles.T3AddRowButtonStyle)
        ctx.theme.registerStyle("t3-table-column", gr.tech.pdfgenerator.styles.t3TableColumnStyle)
        ctx.theme.registerStyle("t3-table-header-column",
                gr.tech.pdfgenerator.styles.t3TableHeaderColumnStyle)
        ctx.theme.registerStyle("t3-header-background",
                gr.tech.pdfgenerator.styles.t3HeaderBackground)
        ctx.theme.registerStyle("t3-table-header", gr.tech.pdfgenerator.styles.t3TableHeaderStyle)
        ctx.theme.registerStyle("t3-fee-table-text",
                gr.tech.pdfgenerator.styles.t3FeeTableTextStyle)
        ctx.theme.registerStyle("t3-qeesm-table-text",
                gr.tech.pdfgenerator.styles.t3QEESMTableTextStyle)
        ctx.theme.registerStyle("t3-document-title-font",
                gr.tech.pdfgenerator.styles.t3DocumentTitleFontStyle)
        ctx.theme.registerStyle("t3-document-section-font",
                gr.tech.pdfgenerator.styles.t3DocumentSectionFontStyle)
        ctx.theme.registerStyle("t3-summary-row-container",
                gr.tech.pdfgenerator.styles.t3SummaryRowContainerStyle)
        ctx.theme.registerStyle("t3-sign-below-list",
                gr.tech.pdfgenerator.styles.t3SignBelowListStyle)
        ctx.theme.registerStyle("t3-sign-below-list-item",
                gr.tech.pdfgenerator.styles.t3SignBelowListItemStyle)
        ctx.theme.registerStyle("t3-sign-box", gr.tech.pdfgenerator.styles.t3SignBoxStyle)
        ctx.theme.registerStyle("t3-sign-box-paragraph",
                gr.tech.pdfgenerator.styles.t3SignBoxParagraphStyle)
        ctx.theme.registerStyle("t3-tight-paragraph",
                gr.tech.pdfgenerator.styles.t3TightParagraphStyle)
        ctx.theme.registerStyle("t3-terms-list", gr.tech.pdfgenerator.styles.t3TermsListStyle)
        ctx.theme.registerStyle("t3-terms-list-alpha",
                gr.tech.pdfgenerator.styles.t3TermsListAlphaStyle)
        ctx.theme.registerStyle("t3-terms-list-item",
                gr.tech.pdfgenerator.styles.t3TermsListItemStyle)
        ctx.theme.registerVariant("-circle", gr.tech.pdfgenerator.styles.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", gr.tech.pdfgenerator.styles.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("gr-loading-spinner",
                gr.tech.pdfgenerator.components.widgets.grLoadingSpinnerAnimation)
        ctx.theme.registerKeyframes("side-menu-slide-in",
                gr.web.icyleds.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("pdf-loading-spinner",
                gr.tech.pdfgenerator.styles.PDFLoadingSpinnerAnimation)
        gr.tech.pdfgenerator.styles.initSiteStyles(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        gr.tech.pdfgenerator.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
